<template>
  <div
    :id="id"
    :style="{ width: '95%', height: '100%', margin: '0 auto' }"
  ></div>
</template>

<script>
export default {
  props: ["id", "chartsData"],
  data() {
    return {};
  },
  watch: {
    chartsData: {
      handler(newvalue, oldvalue) {
        this.drawLine();
      },
      deep: true,
    },
  },

  methods: {
    drawLine() {
      let _this = this;
      if (document.getElementById(this.id) == null) {
        return;
      }
      this.$echarts.dispose(document.getElementById(this.id));
      let myChart = this.$echarts.init(document.getElementById(this.id));
      myChart.setOption({}, true);
      let option = {
        title: {
          text: this.chartsData[0].value + this.chartsData[1].value,
          subtext: "总数",
          left: "center",
          top: "42%", //top待调整
          textStyle: {
            color: "#07796C",
            fontSize: 16,
          },
          subtextStyle: {
            color: "#AAA9A9",
            fontSize: 12,
            top: "50%",
          },
          itemGap: 7, //主副标题间距
        },
        tooltip: {
          trigger: "item",
          formatter: `{b}: {c} ({d}%)`,
        },
        legend: {
          orient: "vertical",
          bottom: "bottom",
        },
        series: [
          {
            type: "pie",
            radius: ["40%", "70%"],
            data: this.chartsData,
            label: {
              formatter: function (param) {
                return param.percent + "%";
                // return (
                //   "{a|" +
                //   (param.percent == undefined ? 0 : param.percent) +
                //   "%" +
                //   "}\n{hr|}\n" +
                //   "{d|" +
                //   param.name +
                //   "}"
                // );
              },
              // rich: {
              //   a: {
              //     padding: [4, 10, 0, 10],
              //     color: "#333",
              //     fontSize: 16,
              //     fontWeight: "bold",
              //   },
              //   d: {
              //     padding: [0, 10, 4, 10],
              //     color: "#A1A7B8",
              //   },
              // },
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      };

      myChart.setOption(option, true);
      setTimeout(() => {
        window.addEventListener("resize", () => {
          myChart.resize();
        });
      }, 20);
    },
  },
  mounted() {},
};
</script>

<style scoped lang="scss">
</style>
